import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import getStatusColor from '../helpers/getStatusColor';
import { LabProcessStatus } from '../hooks/useKits';
interface DotProps {
    status: LabProcessStatus | string;
}
const StatusDot = ({ status }: DotProps) => {
    const classes = useStyles({ status });
    return (
        <div className={classes.base}>
            <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="currentFill"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="7.5" cy="7" r="7" />
            </svg>
        </div>
    );
};

const useStyles = makeStyles<Theme, { status: LabProcessStatus | string }>(
    (theme) => ({
        base: {
            width: '14px',
            height: '14px',
            flexShrink: 0,
            aspectRatio: '1/1',
            fill: (props) => getStatusColor(props.status),
        },
    })
);

export default StatusDot;
